import { UserRole } from '../enums/users/role';

export class AccessConstants {
    static EwaStaffRoles: UserRole[] = [
        UserRole.Admin,
        UserRole.Advisor,
        UserRole.CrmManager,
        UserRole.Accounting,
    ];

    static RolesThatCanManageAllUsers: UserRole[] = [
        UserRole.Admin,
        UserRole.Advisor,
        UserRole.CrmManager,
        UserRole.Accounting,
    ];

    static RolesThatCanManageUserAvailability: UserRole[] = [
        UserRole.Admin,
        UserRole.Advisor,
        UserRole.CrmManager,
    ];

    static RolesThatCanCreateApplicationsForOtherCustomers: UserRole[] = [
        UserRole.Admin,
        UserRole.Advisor,
    ];

    static RolesThatCanCreateApplicationsAndTemplates: UserRole[] = [
        UserRole.Admin,
        UserRole.Advisor,
        UserRole.Customer,
    ];

    /** Roles that can access orders belonging to other users */
    static RolesThatCanAccessAllOrders: UserRole[] = [
        UserRole.Admin,
        UserRole.Advisor,
        UserRole.Accounting,
    ];

    /** Roles that can access orders */
    static RolesThatCanAccessOrders: UserRole[] = [
        UserRole.Admin,
        UserRole.Advisor,
        UserRole.Accounting,
        UserRole.Customer,
    ];

    /**
     * Roles that can manage payments and all operations that are restricted to the most elevated access level.
     */
    static RolesThatCanManageAllPayments: UserRole[] = [
        UserRole.Admin,
        UserRole.Accounting,
    ];

    /**
     * Roles that can manage payments and some operations that are not restricted to the most elevated access level, but still require elevated access to perform.
     */
    static RolesThatCanManagePayments: UserRole[] = [
        UserRole.Admin,
        UserRole.Advisor,
        UserRole.Accounting,
    ];

    /** Roles that can access payment information, but not those belonging to other users **/
    static RolesThatCanAccessPayments: UserRole[] = [
        UserRole.Admin,
        UserRole.Advisor,
        UserRole.Accounting,
        UserRole.Customer,
    ];

    /**
     * Roles that can access QuickBooks reports.
     */
    static RolesThatCanAccessQuickbooksReports: UserRole[] = [
        UserRole.Admin,
        UserRole.Accounting,
    ];

    static getAllUserRoles(): UserRole[] {
        return Object.values(UserRole).filter(
            (role) => typeof role === 'number',
        ) as UserRole[];
    }
}
